import { FC } from 'react'

import { IconName } from 'ui/components/Icon'

import * as SC from './style'

export const SymbolBadge: FC<{
  color: 'default' | 'positive' | 'error' | 'warning' | 'white' | 'grey' | 'none'
  icon: IconName
}> = (props) => {
  const { color, icon } = props

  switch (color) {
    case 'default':
      return <SC.ContainerDefault name={icon} />
    case 'positive':
      return <SC.ContainerPrimary name={icon} />
    case 'warning':
      return <SC.ContainerWarning name={icon} />
    case 'error':
      return <SC.ContainerNegative name={icon} />
    case 'white':
      return <SC.ContainerWhite name={icon} />
    case 'grey':
      return <SC.ContainerGrey name={icon} />
    case 'none':
      return <SC.ContainerNone name={icon} />
  }
}
